import React, { Component } from "react"
import PropTypes from "prop-types"
import Spinner from "shared/components/spinner"

import "./spinner.scss"

export default class Footer extends Component {
  handleSubmit = event => {
    event.preventDefault()
    this.props.onSaveClicked()
  }

  handleDelete = event => {
    event.preventDefault()

    confirm("Are you sure you want to continue?") &&
      this.props.onDeleteClicked()
  }

  render() {
    const { applet, deleteLabel, includeSubmit, enabled, isSaving } = this.props

    return (
      <div className="config-footer">
        {isSaving ? (
          <div styleName="spinner">
            <Spinner
              config={{
                position: "relative",
                top: "inherit",
              }}
            />
          </div>
        ) : (
          includeSubmit && (
            <div className="button">
              <button
                className="button-primary"
                onClick={this.handleSubmit}
                disabled={!enabled}
                data-track-ifttt-next-event="click"
                data-track-data={JSON.stringify({
                  object_type: "connection_update",
                  object_id: `${applet.id}`,
                  location_type: "connection_config",
                })}
              >
                Save
              </button>
            </div>
          )
        )}
        {applet.status !== "never_enabled_for_user" && (
          <div className="delete">
            <a
              onClick={this.handleDelete}
              data-track-ifttt-next-event="click"
              data-track-data={JSON.stringify({
                object_type: "connection_delete",
                object_id: `${applet.id}`,
                location_type: "connection_config",
              })}
            >
              {deleteLabel}
            </a>
          </div>
        )}
      </div>
    )
  }
}

Footer.propTypes = {
  applet: PropTypes.object,
  deleteLabel: PropTypes.string,
  enabled: PropTypes.bool,
  includeSubmit: PropTypes.bool,
  onDeleteClicked: PropTypes.func,
  onSaveClicked: PropTypes.func,
  isSaving: PropTypes.bool.isRequired,
}
